<template>
  <div class="main-content-area cert-list-page">
    <Top />
    <div class="flex justify-between bottom">
      <left />
      <Right />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAsyncData, useNuxtApp, useHead } from '#imports';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Top from './components/Top.vue';
import Left from './components/Left.vue';
import Right from './components/Right.vue';
import { fetchListlInfo } from '~/src/api/modules/certList';
import { useListStore } from '~/src/store/modules/certList';
import { OptionList, ListItem, Tdk } from '~/src/api/modules/certList/types';

const route = useRoute();
const listStore = useListStore();

const setSearchDataToUrl = () => {
  const jointId = route.params.jointId as string;

  if (jointId) {
    const tempArr = extractNumbers(jointId);
    listStore.searchData.jointId = tempArr[0];
    listStore.searchData.page = Number(tempArr[1]) || 1;
  }

  const { pid, cid, tag, cv } = route.query;
  listStore.searchData.pid = pid ? pid : '0';
  listStore.searchData.cid = cid ? cid : '0';
  listStore.searchData.tag = tag ? tag : '0';
  listStore.searchData.cv = cv ? cv : '';
};

const extractNumbers = (inputString: string) => {
  const regex = /jt(.*)_(.*)/;
  const match = inputString.match(regex);

  if (!match) {
    return ['', ''];
  }

  const firstNumber = match[1] || '';
  const rest = match[2] || '';

  return [firstNumber, rest];
};

setSearchDataToUrl();
const nuxtApp = useNuxtApp();
const { data: asyncDataCertList } = await useAsyncData('asyncDataCertList', async () => {
  const res = await fetchListlInfo(listStore.searchData, {}, { nuxtApp });

  return {
    optionList: res.data.optionList,
    certList: res.data.list,
    officeCert: res.data.officeCert,
    hotCert: res.data.hotCert,
    tdk: res.data.tdk,
    parentCateName: res.data.parentCateName,
    certTotal: res.data.pagination.totalCount,
    examArticle: res.data.examArticle,
    commentList: res.data.commentList,
  };
});

listStore.optionList = asyncDataCertList.value?.optionList as OptionList;
listStore.certList = asyncDataCertList.value?.certList as ListItem[];
listStore.officeCert = asyncDataCertList.value?.officeCert as ListItem[];
listStore.hotCert = asyncDataCertList.value?.hotCert as ListItem[];
listStore.tdk = asyncDataCertList.value?.tdk as Tdk;
listStore.parentCateName = asyncDataCertList.value?.parentCateName as string;
listStore.certTotal = asyncDataCertList.value?.certTotal as number;
listStore.examArticle = asyncDataCertList.value?.examArticle;
listStore.commentList = asyncDataCertList.value?.commentList;

// TDK信息
useHead({
  title: listStore.tdk.title,
  meta: [
    {
      name: 'keywords',
      content: listStore.tdk.keyword,
    },
    {
      name: 'description',
      content: listStore.tdk.description,
    },
  ],
});
onMounted(() => {
  // listStore.getOtherData();
});
</script>

<style lang="scss">
.cert-list-page {
  padding-top: 20px;
}
</style>
